import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginFaqsComponent } from '@core-app/layout/login-faqs/login-faqs.component';
import { ActivateComponent } from '@core-app/layout/login/activate.component';
import { LoginComponent } from '@core-app/layout/login/login.component';
import { MainComponent } from '@core-app/layout/main/main.component';
import { MaintenanceComponent } from '@core-app/layout/maintenance/maintenance.component';
import { OopsComponent } from '@core-app/layout/oops/oops.component';
import { PostComponent } from '@core-app/layout/post/post.component';
import { RegisterComponent } from '@core-app/layout/register/register.component';
import { ResetConfirmComponent } from '@core-app/layout/reset/reset-confirm.component';
import { ResetRequestComponent } from '@core-app/layout/reset/reset-request.component';
import { ClientService } from '@core-app/services/client.service';
import { LogoutComponent, PageComponent, PreviewComponent } from '@gallaghercp/core-frontend';
import { APP_CONFIG as LOCAL_APP_CONFIG } from '@core-app/app.config';
import { TokenEntryComponent } from '@core-app/layout/login/token-entry.component';
import { authRouteGuard } from './guards/auth-route.guard';

const staticRoutes: Routes = [
    {
        path: 'maintenance',
        component: MaintenanceComponent,
    },
    {
        path: '404',
        component: OopsComponent,
        pathMatch: 'full',
    },
    {
        path: 'preview',
        component: MainComponent,
        children: [
            {
                path: '',
                component: PreviewComponent,
            },
        ],
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'logout',
        component: LogoutComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'authenticate/:token1/:token2',
        component: TokenEntryComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'reset',
        component: ResetRequestComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'reset/:token',
        component: ResetConfirmComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'activate/:token',
        component: ActivateComponent,
        canActivate: [authRouteGuard],
    },
    {
        path: 'home',
        redirectTo: '/',
    },
    {
        path: 'login-faqs',
        component: LoginFaqsComponent,
    },
];

const articlesParentRoute = (LOCAL_APP_CONFIG as any).articlesParentRoute || 'articles';
const articlesArchiveParentRoute = articlesParentRoute + '-archive';

const childRoutes = [
    {
        path: '',
        component: PageComponent,
    },
    {
        path: ':identifier',
        component: PageComponent,
    },
    {
        path: `${articlesParentRoute}/:identifier`,
        component: PostComponent,
    },
    {
        path: `${articlesArchiveParentRoute}/:identifier`,
        component: PostComponent,
    },
    {
        path: ':parent/:identifier',
        component: PageComponent,
    },
    {
        path: ':parent/:parent2/:identifier',
        component: PageComponent,
    },
];

// Build zonal routes from app.config zoneRouting (array of { id, route })
const zoneRouting: { id: number; route: string }[] = ((LOCAL_APP_CONFIG as any).zoneRouting ?? []) as any[];
const dynamicZonalRoutes: Routes = zoneRouting
    .filter(z => z && z.route && z.id != null)
    .map(z => ({
        path: z.route,
        component: MainComponent,
        canActivate: [ClientService],
        canActivateChild: [ClientService],
        data: { zone: z.id },
        children: childRoutes,
    }));

const defaultRoutes: Routes = [
    ...dynamicZonalRoutes,
    {
        path: '',
        component: MainComponent,
        canActivate: [ClientService],
        canActivateChild: [ClientService],
        ...((LOCAL_APP_CONFIG as any).splashLandingPage?.isZoneRouteOne && { data: { zone: 1 } }),
        children: childRoutes,
    },
];

const routes: Routes = [...staticRoutes, ...defaultRoutes, { path: '**', redirectTo: '/404' }];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            onSameUrlNavigation: 'reload',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
